import {css} from '@emotion/react';
import styled from '@emotion/styled';

import {LayoutContainer} from '@/components/LayoutContainer';

export const Container = styled(LayoutContainer)(
  ({theme}) => css`
    position: relative;

    /* Refactor library LayoutContainer and remove baked-in padding from it */
    && {
      ${theme.spacing({
        paddingBottom: 'pages/large',
        paddingTop: 'pages/small',
      })}
    }
  `
);
